'use strict';
import {stateGo} from 'redux-ui-router';
import {getOrganization} from '../../app/model/reducers/state';
import {SCOPE_DESTROY} from '../../config/constants/view-events';
import {getId} from '../../core-utilities/domain/ReduxUtils';
import {eventToObservable} from '../../core-utilities/rx-utils';


DataTagsManageController.$inject = [
  '$scope',
  '$ngRedux',
  '$stateParams',
  '$ionicViewSwitcher',
  '$popup',
  '$miscUtils',
  'OrganizationDomain',
  'DataTagsService',
  'DataTagsManageFilter',
  'manageTaggablesName',
];

export function DataTagsManageController(
  $scope,
  $ngRedux,
  $stateParams,
  $ionicViewSwitcher,
  $popup,
  $miscUtils,
  OrganizationDomain,
  DataTagsService,
  DataTagsManageFilter,
  manageTaggablesName,
) {
  const vm = $scope.dataTagsMgmt = this;
  const filter = DataTagsManageFilter(vm, $scope);

  vm.goBack = goBack;
  vm.create = $miscUtils.blockPromise(create);

  vm.edit = $miscUtils.blockPromise(edit);
  vm.remove = $miscUtils.blockPromise(remove);

  $scope.$evalAsync(init);

  function init() {
    $ngRedux.state$
      .map(getOrganization)
      .takeUntil(eventToObservable($scope, SCOPE_DESTROY)) // this is probably overkill
      .filter(organization => !!organization)
      .take(1) // Ensures we only get 1 occurrence
      .subscribe(organization => {
        $scope.$evalAsync(() => {
          // TODO(redux-domain): Convert
          vm.organization = organization;
          filter.initFiltering(OrganizationDomain.$getDataTagsList(getId(organization)).$toObservable());
        });
      });
  }

  /*****************************************************************************************************************
   * Header Buttons
   ****************************************************************************************************************/

  function goBack() {
    $ionicViewSwitcher.nextDirection('back');
    $ngRedux.dispatch(stateGo(manageTaggablesName, $stateParams));
  }


  /*****************************************************************************************************************
   * Context Menu Actions
   ****************************************************************************************************************/


  /*****************************************************************************************************************
   * Controller Actions
   ****************************************************************************************************************/

  function create() {
    return DataTagsService.createOrUpdateDataTag(null);
  }

  function edit(tag) {
    return DataTagsService.createOrUpdateDataTag(tag);
  }

  // TODO(i18n): convert to message codes
  function remove(tag) {
    if (!tag) {
      return Promise.resolve(null);
    } else {
      return $popup
        .confirm({
          title: 'Delete Data Tag',
          template: `
<div style="text-align: center;">
  Are you sure you want to delete<br/>
  ${tag.toString()}?<br/>
  This will delete all uses of this data tag.
</div>`,
        })
        .then(result => result ? tag.$delete() : null);
    }
  }


  /*****************************************************************************************************************
   * Presentation Logic
   ****************************************************************************************************************/

}



// WEBPACK FOOTER //
// ./src/js/data-tags/controllers/DataTagsManageController.js